import { Identifiable, Milestone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function removeMilestone(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Milestone>) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/milestones/${uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve())
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { removeMilestone };
